import { Stack, StackProps, Box } from "@mui/material";
import { IRankingData } from "src/components/common/ranking/types";
import { Typography, TypographyProps } from "src/components-mui/base/typography/typography";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { IFractionDigits } from "src/hooks/formatters/number-formatter";
import { ITooltip } from "src/types/common";
import { IRankingValueSize, RankingValue } from "./ranking-value";

export interface IRanking {
    size: IRankingValueSize;
    fractionDigits?: IFractionDigits;
    tooltip?: ITooltip | null;
    data: IRankingData;
    hidePoints?: boolean;
    labelProps?: TypographyProps;
}

export interface IRankingProps extends IRanking, StackProps {}

export const Ranking = ({ data, size, fractionDigits, tooltip, hidePoints, labelProps, ...stackProps }: IRankingProps) => {
    return (
        <Stack
            component="dl"
            direction="column"
            {...stackProps}
            sx={[
                {
                    alignItems: "center",
                    overflow: "hidden",
                    mx: 0.5,
                },
                ...(Array.isArray(stackProps.sx) ? stackProps.sx : [stackProps.sx]),
            ]}
        >
            <Box
                component="dt"
                sx={{
                    fontWeight: "bold",
                    maxWidth: "100%",
                }}
            >
                <RankingValue size={size} data={data} fractionDigits={fractionDigits} hidePoints={hidePoints} />
            </Box>
            <Stack
                component="dd"
                direction="row"
                spacing={0.5}
                sx={{
                    alignItems: "center",
                    maxWidth: "100%",
                }}
            >
                <Typography
                    component="span"
                    noWrap
                    {...labelProps}
                    sx={[
                        {
                            color: "gray.500",
                            fontSize: "xs",
                            wordBreak: "break-all",
                        },
                        ...(Array.isArray(labelProps?.sx) ? labelProps.sx : [labelProps?.sx]),
                    ]}
                >
                    {data.label}
                </Typography>
                {tooltip && <WfPopover PopoverTrigger={<PopoverButtonIconInfo ariaLabel={data.label} />} {...tooltip}></WfPopover>}
            </Stack>
        </Stack>
    );
};
